module.exports = __webpack_public_path__ + "img/nav_mamadays_shop.493741af.png";